import { gameInfoType } from '@op/types/common';
import React from 'react';
import MobileStore from './MobileStore';
import { GameStoreConsole } from '@/pages/opinion/widgets/GameStorePlate';
import Steam from './Steam';
import { useHistory, useIntl } from 'umi';
import CardCommon from '@op/components/CardCommon'; 

export default function GameStore({
  gameInfo,
  ...props
}: {
  gameInfo: gameInfoType;
  filter: any;
  wholeGameInfo: any;
  [key: string]: any;
}) {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const handleTitleOnClick = () => {
    history.push('/opinion/Feeds/Feeds?tab=gameStore');
  };

  if (gameInfo?.entity_type === 'mobile') {
    return (
      <MobileStore
        // games={[]}
        // gameData={undefined}
        // showRank={false}
        gameInfo={gameInfo}
        {...props}
      ></MobileStore>
    );
  }

  if (gameInfo.entity_type === 'console') {
    return (
      <CardCommon
        className="card-common-dbo-key-metrics-steam card-slot"
        contentCard
        title={
          <span style={{ fontSize: 20 }}>
            {formatMessage({ id: 'Game Store' })}
          </span>
        }
        hasTitleArrow
        handleTitleOnClick={() => handleTitleOnClick()}
      >
        <GameStoreConsole
          filter={props.filter}
          gameInfo={gameInfo}
          handleTitleOnClick={handleTitleOnClick}
        />
      </CardCommon>
    );
  }
  return (
    <Steam
      // gameData={undefined}
      // games={[]}
      // showRank={false}
      gameInfo={gameInfo}
      {...props}
    ></Steam>
  );
}
